/* 线性图标集 · 统一 stroke 1.75（令牌 --stroke-icon），24 网格
 * 装饰性图标一律 aria-hidden，语义由相邻文本承担（V2 实测多页 svg 缺 label）。 */
import type { CSSProperties } from 'react';

export type IconName =
  | 'home' | 'chart' | 'map' | 'factory' | 'target' | 'calendar' | 'gauge' | 'flow'
  | 'stamp' | 'bolt' | 'beaker' | 'layers' | 'sliders' | 'orders' | 'check' | 'users'
  | 'box' | 'db' | 'wrench' | 'radar' | 'dna' | 'shield' | 'plug' | 'bot'
  | 'menu' | 'left' | 'right' | 'sun' | 'moon' | 'close' | 'search' | 'star' | 'clock'
  | 'download' | 'upload' | 'plus' | 'info' | 'warn' | 'sparkle';

const P: Record<IconName, string> = {
  home: 'M3 10.5 12 3l9 7.5M5.5 9.5V20h13V9.5',
  chart: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  map: 'M9 3 3 5.5v15L9 18l6 3 6-2.5v-15L15 6 9 3zM9 3v15M15 6v15',
  factory: 'M3 21V10l5 3.5V10l5 3.5V10l5 3.5V21H3zM6 21v-4h3v4M15 21v-4h3v4',
  target: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z',
  calendar: 'M3 8h18M7 3v4M17 3v4M4 5h16v16H4V5z',
  gauge: 'M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zM12 12l4-4',
  flow: 'M4 6h6M14 6h6M4 18h6M14 18h6M10 6a2 2 0 1 0 4 0 2 2 0 0 0-4 0zM10 18a2 2 0 1 0 4 0 2 2 0 0 0-4 0zM12 8v8',
  stamp: 'M6 21h12M9 17V9a3 3 0 0 1 6 0v8M6 17h12v4H6z',
  bolt: 'M13 2 4 14h7l-1 8 9-12h-7l1-8z',
  beaker: 'M9 3v6L4 19a2 2 0 0 0 2 3h12a2 2 0 0 0 2-3l-5-10V3M8 3h8M7 14h10',
  layers: 'm12 3 9 5-9 5-9-5 9-5zM3 13l9 5 9-5M3 17l9 5 9-5',
  sliders: 'M4 6h10M18 6h2M4 12h4M12 12h8M4 18h10M18 18h2M14 4v4M8 10v4M14 16v4',
  orders: 'M6 3h9l4 4v14H6V3zM14 3v5h5M9 13h7M9 17h7',
  check: 'M4 12.5 9 18l11-12',
  users: 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM2 21a7 7 0 0 1 14 0M17 11a3 3 0 1 0 0-6M18 21a6 6 0 0 0-2-4.5',
  box: 'm12 3 8 4.5v9L12 21l-8-4.5v-9L12 3zM4 7.5l8 4.5 8-4.5M12 12v9',
  db: 'M12 8c4.4 0 8-1.1 8-2.5S16.4 3 12 3 4 4.1 4 5.5 7.6 8 12 8zM4 5.5v13C4 19.9 7.6 21 12 21s8-1.1 8-2.5v-13M4 12c0 1.4 3.6 2.5 8 2.5s8-1.1 8-2.5',
  wrench: 'M15 3a5 5 0 0 0-4.6 7L3 17.4 5.6 20 13 12.6A5 5 0 1 0 15 3z',
  radar: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 17a5 5 0 1 0 0-10M12 12l6-6',
  dna: 'M6 3c0 6 12 6 12 12M18 3c0 6-12 6-12 12M6 21h12M6 3h12M8 8h8M8 16h8',
  shield: 'm12 3 8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z',
  plug: 'M9 3v6M15 3v6M7 9h10v3a5 5 0 0 1-10 0V9zM12 17v4',
  bot: 'M8 8h8a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3v-5a3 3 0 0 1 3-3zM12 4v4M9.5 13v1M14.5 13v1',
  menu: 'M4 7h16M4 12h16M4 17h16',
  left: 'm14 6-6 6 6 6',
  right: 'm10 6 6 6-6 6',
  sun: 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
  moon: 'M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z',
  close: 'M6 6l12 12M18 6 6 18',
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM21 21l-4.3-4.3',
  star: 'm12 3 2.8 5.7 6.2.9-4.5 4.4 1 6.2-5.5-2.9-5.5 2.9 1-6.2L3 9.6l6.2-.9L12 3z',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2',
  download: 'M12 3v12M7 11l5 5 5-5M4 21h16',
  upload: 'M12 21V9M7 13l5-5 5 5M4 3h16',
  plus: 'M12 5v14M5 12h14',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 11v6M12 7.5v.5',
  warn: 'M12 3 2 20h20L12 3zM12 9v5M12 17v.5',
  sparkle: 'm12 3 1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z',
};

interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
  style?: CSSProperties;
  /** 极少数情况下图标独立承载语义时传入，其余一律装饰性 */
  label?: string;
}

export function Icon({ name, size = 16, className, style, label }: IconProps) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="var(--stroke-icon)"
      strokeLinecap="round" strokeLinejoin="round"
      className={className} style={style}
      aria-hidden={label ? undefined : true}
      role={label ? 'img' : undefined}
      aria-label={label}
      focusable="false"
    >
      <path d={P[name]} />
    </svg>
  );
}
